<template>
  <div style="padding:60px">
    <span>{{msg}}</span>
    <div style="margin-top:20px" v-if="registerShow">
      <img :src="require('~/assets/images/qrcode.png')" width="200" alt="请关注：‘乐跳会员’公众号" title="乐跳会员公众号" />
      <p>请用微信“扫一扫”扫描上方二维码关注公众号，并注册“企业版”</p>
    </div>
  </div>
</template>

<script>
  import { unionIDLogin, hrLogin } from '~/api/account.js';
  export default {
    data() {
      return {
        unionId: '',
        page: '',
        msg: '',
        registerShow: false
      };
    },
    created() {
      this.unionId = this.$route.query.unionId;
      this.page = this.$route.query.page;
      if(this.unionId){
        this.login();
      } else {
        this.msg = '微信登录失败，原因：未获取微信用户信息';
      }
    },
    methods: {
      login(){
        this.msg = '扫描成功，正在登录，请稍后……';
        var params = {
          unionId: this.unionId,
          sign: this.$Global.HR_SIGNCODE
        };
        unionIDLogin(params).then( m => {
          if(m.errcode === 0){
            let user = m.data;
            this.access_token = user.token;
            this.$store.dispatch('Login', user);
            this.$store.commit('setToken', this.access_token);
            this.$emit('refreshUser', user);
            hrLogin().then( n => {
              if (n.errcode === 0) {
                var hrData = n.data;
                this.$store.dispatch('HrLogin', hrData);                
                this.msg = '登录成功';
                switch(hrData.hr_state){
                case 1:
                  this.$router.push('/TalentIndex');
                  break;
                case 4:
                  this.$router.push('/VerifyFail');
                  break;
                case 6:
                  this.$router.push('/UploadLicence');
                  break;                  
                case 7:
                  this.$router.push('/VerifyWait');
                  break;
                default:
                  this.$router.push('/JobIndex');
                  break;
                }
                
              }
            }); 
          } else {
            this.msg = '登录失败，原因：' + m.errmsg;
            if(m.errcode == 11009){
              this.registerShow = true;
            }
          }
        }).catch( err => {
          this.msg = '登录失败，原因：' + err;
        });
      }   
    }
  };
</script>

<style scoped>

</style>